import { PageHeaderInfoButton } from './PageHeaderInfoButton';
import type { PageHeaderTitleProps } from './PageHeader.types';

/**
 * Page title for top-level destinations. Owns the 2px gap to its own info
 * button so that spacing cannot drift between the variants that carry one.
 */
export function PageHeaderTitle(props: PageHeaderTitleProps) {
  return (
    <div className="flex min-w-0 items-center gap-3xs">
      <h1 data-testid="page-header-title" className="type-body-md-strong truncate text-foreground">
        {props.children}
      </h1>
      {props.info && <PageHeaderInfoButton page={props.children} onClick={props.info.onClick} />}
    </div>
  );
}
